/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Offer_Record_TitleInputs */

const en_us2_share_offer_record_title = /** @type {(inputs: Share_Offer_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New record! Want to show it?`)
};

const pt_br2_share_offer_record_title = /** @type {(inputs: Share_Offer_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recorde novo! Que tal mostrar?`)
};

const es_419_share_offer_record_title = /** @type {(inputs: Share_Offer_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Nuevo récord! ¿Lo muestras?`)
};

const pt_pt2_share_offer_record_title = /** @type {(inputs: Share_Offer_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recorde novo! Que tal mostrá-lo?`)
};

const fr_fr2_share_offer_record_title = /** @type {(inputs: Share_Offer_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau record ! Tu le montres ?`)
};

const de_de2_share_offer_record_title = /** @type {(inputs: Share_Offer_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Rekord! Willst du ihn zeigen?`)
};

const it_it2_share_offer_record_title = /** @type {(inputs: Share_Offer_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo record! Vuoi mostrarlo?`)
};

/**
* | output |
* | --- |
* | "New record! Want to show it?" |
*
* @param {Share_Offer_Record_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_offer_record_title = /** @type {((inputs?: Share_Offer_Record_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Offer_Record_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_offer_record_title(inputs)
	if (locale === "es-419") return es_419_share_offer_record_title(inputs)
	if (locale === "pt-PT") return pt_pt2_share_offer_record_title(inputs)
	if (locale === "fr-FR") return fr_fr2_share_offer_record_title(inputs)
	if (locale === "de-DE") return de_de2_share_offer_record_title(inputs)
	if (locale === "it-IT") return it_it2_share_offer_record_title(inputs)
	return en_us2_share_offer_record_title(inputs)
});
export { share_offer_record_title as "share.offer_record_title" }